'use client';
import { useState, useEffect } from 'react';
import { getLocationState, subscribeLocation, initLocation } from '@/lib/location';
import type { LocationState } from '@/lib/location';

export function useLocation(): LocationState {
  const [state, setState] = useState<LocationState>(getLocationState);

  useEffect(() => {
    initLocation();
    const unsubscribe = subscribeLocation((s) => setState(s));
    // Sync in case state changed between initial render and effect mount
    setState(getLocationState());
    return unsubscribe;
  }, []);

  return state;
}
